import { StoreCogIcon } from './StoreCogIcon';

/**
 * author: Colton Wiscombe
 * id 0D8DEFE4-8A1E-4106-96FA-4663891F40FD
 * name store-cog
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-cog.svg
 * tags
 * - Places 
 * - Shopping 
 * - Settings 
 */
export const ShopSettingsIcon = StoreCogIcon;
export default ShopSettingsIcon